import { getUrlExtension } from './get-url-extension';

const types = Object.freeze({
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg',
});

export const getAudioType = (src) => {
  const extension = getUrlExtension(src);
  return types[extension] || '';
};
